__turbopack_context__.v({
  "accommodationName": "TFdQkG_accommodationName",
  "basketImageWrapper": "TFdQkG_basketImageWrapper",
  "benefits": "TFdQkG_benefits",
  "benefitsIcon": "TFdQkG_benefitsIcon",
  "checkoutSection": "TFdQkG_checkoutSection",
  "content": "TFdQkG_content",
  "flightLegDetails": "TFdQkG_flightLegDetails",
  "flightTimeline": "TFdQkG_flightTimeline",
  "header": "TFdQkG_header",
  "headingGroup": "TFdQkG_headingGroup",
  "item": "TFdQkG_item",
  "itemBody": "TFdQkG_itemBody",
  "itemContent": "TFdQkG_itemContent",
  "itemHeaderText": "TFdQkG_itemHeaderText",
  "itemLine": "TFdQkG_itemLine",
  "location": "TFdQkG_location",
  "mobileContent": "TFdQkG_mobileContent",
  "mobileTotalBottom": "TFdQkG_mobileTotalBottom",
  "mobileTotalBottomOnTop": "TFdQkG_mobileTotalBottomOnTop",
  "mobileTotalBottomPrice": "TFdQkG_mobileTotalBottomPrice",
  "packageDetails": "TFdQkG_packageDetails",
  "packageDetailsDescription": "TFdQkG_packageDetailsDescription",
  "packageDetailsLabel": "TFdQkG_packageDetailsLabel",
  "packageDetailsRow": "TFdQkG_packageDetailsRow",
  "packageDetailsValue": "TFdQkG_packageDetailsValue",
  "pinnedHeader": "TFdQkG_pinnedHeader",
  "priceSummary": "TFdQkG_priceSummary",
  "priceSummaryDiscount": "TFdQkG_priceSummaryDiscount",
  "priceSummaryItem": "TFdQkG_priceSummaryItem",
  "priceSummaryMandatoryIncluded": "TFdQkG_priceSummaryMandatoryIncluded",
  "priceSummaryRow": "TFdQkG_priceSummaryRow",
  "priceSummarySupportingText": "TFdQkG_priceSummarySupportingText",
  "priceSummaryTotal": "TFdQkG_priceSummaryTotal",
  "rebookingBanner": "TFdQkG_rebookingBanner",
  "stickyTrack": "TFdQkG_stickyTrack",
  "totalPrice": "TFdQkG_totalPrice",
  "totalPriceFooter": "TFdQkG_totalPriceFooter",
  "totalPriceRebookingPackagePrice": "TFdQkG_totalPriceRebookingPackagePrice",
  "totalPriceRow": "TFdQkG_totalPriceRow",
  "totalPriceSubtext": "TFdQkG_totalPriceSubtext",
});
